(function () {
    'use strict';

    var module = angular.module('uwAgenda.tasks');
    /* represent task object */
    module.factory('Task', ['$rootScope', 'UserDto', 'TaskStateEnum', 'HelperService', 'SharedAgendaService', 'CallsService',
        function ($rootScope, UserDto, TaskStateEnum, HelperService, SharedAgendaService, CallsService) {
            var Task = function (isToDo) {

                // default attributes for a new task !

                // set type (isTodo or daytask)
                this.isToDo = typeof isToDo !== 'undefined' && isToDo === 'true' ? true : false;
                this.taskState = TaskStateEnum.InProgress.value; // default InProgress
                this.deadline = null;
                this.alertDateTime = null;
                this.sendAlertMessage = false;
                this.flag = null;
                // creator/owner of task
                this.fK_User = null;
                // selected patient of task
                this.fK_Patient = null;
                // assigned agenda
                //this.fK_Agenda = this.isToDo ? null : SharedAgendaService.currentUser().agendaId;
                this.fK_Agenda = null;
                // user dto
                this.userDto = new UserDto();
                // pin to user dto
                this.pinToUserDto = null; //default null
                // patient dto 
                this.patientDto = {};
                // reactions list
                this.reactions = [];
                // caller info
                this.callGuid = null;
                this.callerNumber = null;

                // vm
                // for the backend
                this.content = '';

                // for the view
                this.vmId = null; // random id for tracking -> so DOM is removed if needed
                this.vmStatusColor = null;
                this.vmReadonly = false; // is task editable or just readonly
                this.vmTaskState = null; // taskState for view -> sometimes followUpByOperator and followUpByRingfoon are combined


                // init /constructor
                this.init();
            };


            // init task
            Task.prototype.init = function () {
                var self = this;
                // set correct creator of task -> always logged in user
                var loggedInUser = SharedAgendaService.getLoggedInUserData();
                self.fK_User = loggedInUser.id;
                self.userDto.id = loggedInUser.id;
                self.userDto.caption = loggedInUser.firstName;

                // init task states
                initTaskState(self);

                // update vm attributes
                updateVm(self);
            };


            /* init task -> extend object */
            Task.prototype.extend = function (task) {
                var self = this;
                angular.extend(self, task);

                // reactions list
                self.reactions = task.reactions || [];

                // set correct task-state if new object
                if (self.id <= 0) {
                    initTaskState(self);
                } //if

                // update vm attributes
                updateVm(self);

                /// only the creator/owner of the task can update
                if (self.isToDo === 'true' || self.isToDo === true) {
                    // private tasks
                    if (SharedAgendaService.getLoggedInUserData().id !== self.fK_User) {
                        self.vmReadonly = true;
                    } // if
                } // if
                else {
                    // shared client id must match
                    if (SharedAgendaService.data.currentAgenda.id !== self.fK_Agenda) {
                        self.vmReadonly = true;
                    } //if
                } //else
            }; // extend


            // prepare some attributes for backend-api
            Task.prototype.prepareForBackend = function () {
                var self = this;

                // call guid and number if available (concat)
                self = CallsService.setGuidToEntity(self);

                // pin to user object to id
                self.fK_PinTo_User = null;
                if (self.pinToUserDto) {
                    self.fK_PinTo_User = self.pinToUserDto.id;
                }

                // pinned to date -> only Date no time
                if (self.pinnedToDate !== null) {
                    self.pinnedToDate = HelperService.backendDate(HelperService.date(self.pinnedToDate));
                }

                delete self.userDto;
                delete self.pinToUserDto;
                delete self.statusColor;
                delete self.vmStatusColor;
                delete self.vmReadonly;
                delete self.vmTaskState;
                delete self.vmId;
            };


            // update vm attributes
            Task.prototype.updateVm = function () {
                var self = this;
                updateVm(self);
            };

            // set vm-task-state depending on current logged in user
            function vmTaskState(self) {
                self.vmTaskState = self.taskState; // first the same
            } //vmTaskState


            // get status color by taskstatus
            function vmStatusColor(self) {
                self.vmStatusColor = 'green-soft'; // default
                switch (self.taskState) {
                    case TaskStateEnum.InProgress.value: self.vmStatusColor = 'blue-soft'; break;
                    case TaskStateEnum.Finished.value: self.vmStatusColor = 'green-soft'; break;
                    case TaskStateEnum.FollowUpByOperator.value: self.vmStatusColor = 'red-soft'; break;
                    case TaskStateEnum.FollowUpByRingfoon.value: self.vmStatusColor = 'red-soft'; break;
                }

                // is deactivated ?
                if (self.isDeactivated === true) {
                    self.vmStatusColor = 'yellow-soft';
                } //if
            } // vmStatusColor

            // function for updating vm-attributes !
            function updateVm(self) {
                // vm id 
                self.vmId = Math.random();
                // status color
                vmStatusColor(self);
                // task state
                vmTaskState(self);

                // Update Reactions
                var ri = 0;
                var len = self.reactions.length;
                for (ri; ri < len; ri++) {
                    if (self.reactions[ri].reactionByRingphone) {
                        self.reactions[ri].vmUserColor = 'font-red-soft';
                    } // if
                    else { self.reactions[ri].vmUserColor = 'font-blue-soft'; }
                } // for
            } // updateVm


            // init correct task-state if new object
            function initTaskState(self) {
                //// depending on current user -> set and show correct task-state

                // if main-user -> follow-up-by-operator
                // if operator -> in-progress
                // if urgent-to-do -> in-progress
                if (self.isToDo === true || self.isToDo === 'true') {
                    // in-progress                 
                    self.taskState = TaskStateEnum.InProgress.value;
                } //if
                else {
                    // daytasks

                    /// if ringfoon -> in-progress
                    if ($rootScope.isRingfoon) {
                        // in-progress                 
                        self.taskState = TaskStateEnum.InProgress.value;
                    } //if
                    else {
                        /// Client/Doktor
                        /// SecretaryLicence -> Follow-Up-By-Operator
                        /// If NOT -> in-progress
                        if (SharedAgendaService.currentUser().isSecretaryLicence === true) {
                            // follow-up-by-operator                 
                            self.taskState = TaskStateEnum.FollowUpByOperator.value;
                        } //if
                        else {
                            // in-progress                 
                            self.taskState = TaskStateEnum.InProgress.value;
                        } //else

                    } //else
                } // else
            } // initTaskState




            return Task;
        }]);
})();